export default "__VITE_ASSET__B6mMFi5s__"